export const languageElements = {
  items: {
    "flush-filter": {
      hu: "Adatok előszűrése",
      de: "Daten filtern",
      en: "Filtering data",
    },

    "flush-data": {
      hu: "Raktári mozgások",
      de: "Journal",
      en: "Journal",
    },
    "field-Mozgasszam": {
      hu: "Mozgásszám",
      de: "Bewegungsnummer",
      en: "Movement no.",
    },
    "field-Raktarberlo": {
      hu: "Raktárbérlő",
      de: "Kunde",
      en: "Renter",
    },
    "field-BeerkezesDatuma": {
      hu: "Beérkezés dátuma",
      de: "Ankunft datum",
      en: "Incoming date",
    },
    "field-SzallitolevelSzama": {
      hu: "Szállítólevél száma",
      de: "Lieferschein nr.",
      en: "Delivery note no.",
    },
    "field-Cikkszam": {
      hu: "Cikkszám",
      de: "Artikel nr.",
      en: "Item no.",
    },
    "field-Termekleiras": {
      hu: "Termékleírás",
      de: "Artikel beschreibung",
      en: "Item description",
    },
    "field-Darab": {
      hu: "Darab",
      de: "Anz",
      en: "Pcs",
    },
    "field-Suly": {
      hu: "Súly",
      de: "Gewicht",
      en: "Weight",
    },
    "field-Sarzs": {
      hu: "Sarzs",
      de: "Batch no.",
      en: "Batch no.",
    },
    "field-Lejarat": {
      hu: "Lejarat",
      de: "MHD",
      en: "Expiry date",
    },
    "field-Barcode": {
      hu: "Barcode",
      de: "Barcode",
      en: "Barcode",
    },
    "field-Elkonyvelve": {
      hu: "Elkönyvelve",
      de: "Gebuckt",
      en: "Booked",
    },
    "field-Mozgasnem": {
      hu: "Mozgásnem",
      de: "Bewegungsart",
      en: "Type of movement",
    },
    "MOVEMENTIN": {
      hu: "Betár",
      de: "Einlagerung",
      en: "Movement IN",
    },
    "MOVEMENTOUT": {
      hu: "Kitár",
      de: "Auslagerung",
      en: "Movement OUT",
    },

    "field-externalSystemId": {
      hu: "External System ID",
      de: "External System ID",
      en: "External System ID",
    },  
    "field-PartnerId": {
      hu: "Partner ID",
      de: "Partner ID",
      en: "Partner ID",
    },  
    "field-hasDocuments": {
      hu: "Dokumentumok feltöltve",
      de: "Beigefügte Dokumente",
      en: "Attached documents",
    },
  },
};
